import styled from 'styled-components';

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-bottom: 12px;

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black9};
  margin-bottom: 16px;
  margin-top: 24px;

  &:first-child {
    margin-top: 0;
  }
`;

export const RequiredFieldNote = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black10};
  margin: 0;
`;

export const SubtitleText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black9};
  line-height: 20px;
  margin: 0;
`;

export const TitlesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FieldLabel = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black9};

  .required {
    color: ${({ theme }) => theme.colors.red6};
  }
`;

export const DocumentInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;

  .type-selector {
    min-width: 140px;

    .ant-form-item {
      margin-bottom: 0;
    }
  }

  .number-input {
    flex: 1;

    .ant-form-item {
      margin-bottom: 0;
    }
  }
`;
